import { render, staticRenderFns } from "./postscript.vue?vue&type=template&id=1436d452&scoped=true"
import script from "./postscript.vue?vue&type=script&lang=js"
export * from "./postscript.vue?vue&type=script&lang=js"
import style0 from "./postscript.vue?vue&type=style&index=0&id=1436d452&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1436d452",
  null
  
)

export default component.exports